// src/components/Products.tsx

import { useFormik } from "formik";
import * as Yup from "yup";
import {
  TextField,
  MenuItem,
  Switch,
  FormControlLabel,
  Button,
  Grid,
  Typography,
  Box,
  Breadcrumbs,
  Divider,
  Card,
  InputLabel,
  FormControl,
  Select,
  Stack,
  Checkbox,
  Autocomplete,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import Link from "@mui/material/Link";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Layout from "../../layout/Layout";
import ImageUploader from "./ImageUpload";
import { Backdrop, CircularProgress } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { apiData } from "../../services/api_service";
import {
  addProductAPI,
  fetchCategoriesDDAPI,
  fetchProductByIdAPI,
  updateProductAPI,
} from "../../config";
import { AlertMessage } from "../../components/AlertMessage";
import { LoadingButton } from "@mui/lab";

const validationSchema = Yup.object({
  product_name: Yup.string()
    .required("Product name is required")
    .min(3, "Minimum 3 characters required")
    .max(100, "Maximum 100 characters required"),

  color: Yup.string()
    .required("Color is required")
    .min(3, "Minimum 3 characters required")
    .max(100, "Maximum 100 characters required"),

  size: Yup.string()
    .required("Size is required")
    .min(3, "Minimum 3 characters required")
    .max(100, "Maximum 100 characters required"),

  reorder_level: Yup.number()
    .typeError("Enter a number")
    .min(0, "Cannot be negative"),

  bar_code: Yup.string()
    .required("Bar Code is required")
    .min(3, "Minimum 3 characters required")
    .max(100, "Maximum 100 characters required"),

  sku: Yup.string()
    .required("SKU is required")
    .matches(/^[a-zA-Z0-9-_]+$/, "Invalid SKU format"),

  category: Yup.number().required("Category is required"),
  uom: Yup.number().required("UOM is required"),
  // selling_price: Yup.number()
  //   .required("Selling price is required")
  //   .moreThan(
  //     Yup.ref("buying_price"),
  //     "Selling price must be greater than Buying price"
  //   ),

  // buying_price: Yup.number()
  //   .required("Buying price is required")
  //   .min(0, "Cannot be negative"),

  // quantity: Yup.number()
  //   .required("Quantity is required")
  //   .min(0, "Cannot be negative"),

  // reorder_level: Yup.number()
  //   .required("Reorder level is required")
  //   .min(0, "Cannot be negative")
  //   .max(Yup.ref("quantity"), "Cannot exceed current stock"),

  // threshold_limit: Yup.number()
  //   .required("Threshold limit is required")
  //   .min(0, "Cannot be negative")
  //   .max(Yup.ref("quantity"), "Cannot exceed current stock"),

  // allow_backorder: Yup.boolean(),

  // backorder_limit: Yup.number().when("allow_backorder", {
  //   is: true,
  //   then: Yup.number()
  //     .required("Backorder limit is required")
  //     .min(0, "Cannot be negative"),
  //   otherwise: Yup.number().notRequired(),
  // }),

  description: Yup.string().max(500, "Max 500 characters allowed"),

  // image: Yup.array()
  //   .min(1, "At least one image is required")
  //   .required("Image is required"),
});

const Products = () => {
  const user = JSON.parse(localStorage.getItem("user"));

  const alertRef = useRef();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      product_name: "",
      sku: "",
      category: "",
      color: "",
      size: "",
      bar_code: "",
      selling_price: "",
      buying_price: "",
      quantity: "",
      threshold_limit: "",
      reorder_level: 0,
      // allow_backorder: "",
      // backorder_limit: "",
      description: "",
      adjustmentType: "",
      stockAdjustment: "",
      image: [],
      note: "",
      out_of_stock: 1,
      uom: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        // values.allow_backorder = values.allow_backorder ? 1 : 0;
        values.user_id = user.emp_id;
        if (!id) {
          values.out_of_stock = 0;
        }
        const apiUrl = id ? `${updateProductAPI}/${id}` : addProductAPI;
        const method = id ? "patch" : "post";

        const changedFields = {};
        for (const key in values) {
          const current = values[key];
          const initial = initialValues?.[key];

          if (!id || current !== initial) {
            if (current !== undefined && current !== null) {
              changedFields[key] = current;
            }
          }
        }

        const formData = new FormData();

        if (Object.keys(changedFields).length === 0) {
          alertRef.current.triggerAlert(
            JSON.stringify({
              message: "No changes detected to save.",
              messageType: "info",
            })
          );
          return;
        }
        // if (Array.isArray(changedFields.image)) {
        //   const existingImages = [];

        //   changedFields.image.forEach((img) => {
        //     if (!img) {
        //       console.log("Skipping null/undefined image:", img);
        //       return;
        //     }

        //     // Skip only if it's an empty plain object (NOT a File)
        //     if (
        //       typeof img === "object" &&
        //       !(img instanceof File) &&
        //       Object.keys(img).length === 0
        //     ) {
        //       console.log("Skipping empty plain object image:", img);
        //       return;
        //     }

        //     if (img instanceof File) {
        //       formData.append("image", img);
        //     } else if (img && img.file instanceof File) {
        //       formData.append("image", img.file);
        //     } else if (typeof img === "string") {
        //       existingImages.push(img);
        //     }
        //   });

        //   if (existingImages.length > 0) {
        //     formData.append("existingImages", JSON.stringify(existingImages));
        //   }
        // }

        // // Always delete even if it was empty
        // delete changedFields.image;

        // for (const key in changedFields) {
        //   formData.append(key, changedFields[key]);
        // }
        for (const key in changedFields) {
          const value = changedFields[key];
          if (typeof value === "object") {
            // If object (not file), stringify
            formData.append(key, JSON.stringify(value));
          } else {
            formData.append(key, value);
          }
        }

        if (values.id) {
          formData.append("id", id);
        }

        const result = await apiData(method, apiUrl, formData);

        if (result.success) {
          alertRef.current.triggerAlert(
            JSON.stringify({
              message: result.msg,
              messageType: "success",
            })
          );

          setTimeout(() => {
            navigate("/product/list");
          }, 3000);
        } else {
          alertRef.current.triggerAlert(
            JSON.stringify({
              message: result.msg,
              messageType: "error",
            })
          );
        }
      } catch (error) {
        alertRef.current.triggerAlert(
          JSON.stringify({
            message: error.msg,
            messageType: "error",
          })
        );
      } finally {
        setLoading(false);
      }
    },
  });

  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    async function fetchProduct() {
      if (id) {
        const result = await apiData("get", `${fetchProductByIdAPI}/${id}`);

        if (result.success && result.data.length > 0) {
          const product = result.data[0];
          const values = {
            product_name: product.product_name || "",
            sku: product.sku || "",
            color: product.color || "",
            size: product.size || "",
            bar_code: product.bar_code || "",
            category: product.category || "",
            selling_price: product.selling_price || "",
            buying_price: product.buying_price || "",
            quantity: product.quantity || "",
            threshold_limit: product.threshold_limit || "",
            reorder_level: product.reorder_level ?? 0,
            // allow_backorder: parseInt(product.allow_backorder) === 1,
            // backorder_limit: product.backorder_limit || "",
            description: product.description || "",
            adjustmentType: "",
            stockAdjustment: "",
            image: product.image ? JSON.parse(product.image) : [],
            out_of_stock: parseInt(product.out_of_stock) || 0,
            uom: product.uom || "",
          };
          setInitialValues(values);
          formik.setValues(values);
        } else {
          alertRef.current.triggerAlert(
            JSON.stringify({
              message: result.msg,
              messageType: "error",
            })
          );
        }
      }
    }
    fetchProduct();
  }, [id]);

  const [categories, setCategories] = useState([]);
  const [uom, setUOMList] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const [categoryResult, uomResult] = await Promise.all([
          apiData("GET", `${fetchCategoriesDDAPI}/213`),
          apiData("GET", `${fetchCategoriesDDAPI}/216`),
        ]);

        if (categoryResult.success && uomResult.success) {
          // active category
          const activeCategory = categoryResult.data.result.filter(
            (cat) => cat.status === 1
          );
          setCategories(activeCategory);

          // active UOM
          const activeUOM = uomResult.data.result.filter(
            (uom) => uom.status === 1
          );
          setUOMList(activeUOM);
        } else {
          alertRef.current.triggerAlert(
            JSON.stringify({
              message: categoryResult.msg || uomResult.msg,
              messageType: "error",
            })
          );
        }
      } catch (err) {
        alertRef.current.triggerAlert(
          JSON.stringify({
            message: err.message || "Something went wrong",
            messageType: "error",
          })
        );
      }
    }

    fetchData();
  }, []);

  return (
    <Layout>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box sx={{ p: { xs: 2, sm: 4, md: 6 } }}>
        <Grid container spacing={2} alignItems="center">
          <AlertMessage ref={alertRef} />

          <Grid item xs={12} sm={6}>
            <Typography className="page_title">Add Product</Typography>
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="inherit" href="/dashboard">
                Dashboard
              </Link>
              <Typography color="text.primary">Product</Typography>
              <Typography color="text.primary">Add</Typography>
            </Breadcrumbs>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} textAlign="right">
            <LoadingButton
              size="medium"
              variant="contained"
              color="success"
              className="button_first"
              onClick={() => navigate("/product/list")}
              sx={{
                fontSize: {
                  xs: "0.7rem",
                  sm: "0.8rem",
                  md: "0.9rem",
                  lg: "0.9rem",
                },
                padding: {
                  xs: "4px 10px",
                  sm: "6px 12px",
                  md: "8px 16px",
                  lg: "2px 10px",
                },
                mb: { xs: -1, sm: -0, md: 1, lg: 0 },
              }}
            >
              LIST PRODUCTS
            </LoadingButton>
            {!id && (
              <Button
                size="medium"
                variant="contained"
                sx={{
                  mb: { xs: -1, sm: -0, md: 1, lg: 0 },
                  fontSize: {
                    xs: "0.7rem",
                    sm: "0.8rem",
                    md: "0.9rem",
                    lg: "0.9rem",
                  },
                  padding: {
                    xs: "4px 8px",
                    sm: "6px 12px",
                    md: "8px 16px",
                    lg: "2px 10px",
                  },
                  backgroundColor: "#0c54a0",
                  "&:hover": { backgroundColor: "#083e78" },
                }}
                className="button_first"
                onClick={() => navigate("/product/bundle-add")}
              >
                ADD BUNDLE
              </Button>
            )}
            {!id && (
              <Button
                size="medium"
                variant="contained"
                sx={{
                  // ml: { xs: 0, sm: 1, md: 2, lg: 2 },
                  // mt: { xs: 1, sm: 0, md: 0, lg: 0 },
                  mb: { xs: -1, sm: -0, md: 1, lg: 0 },
                  fontSize: {
                    xs: "0.7rem",
                    sm: "0.8rem",
                    md: "0.9rem",
                    lg: "0.9rem",
                  },
                  padding: {
                    xs: "4px 8px",
                    sm: "6px 12px",
                    md: "8px 16px",
                    lg: "2px 10px",
                  },
                  backgroundColor: "#7B1FA2",
                  "&:hover": { backgroundColor: "#6A1B9A" },
                }}
                className="button_first"
                onClick={() => navigate("/product/bulk-upload")}
                // startIcon={<AddIcon />}
              >
                BULK UPLOAD
              </Button>
            )}
            <LoadingButton
              size="medium"
              variant="contained"
              color="primary"
              onClick={() => navigate(-1)}
              startIcon={<ArrowBackIosIcon />}
              sx={{
                // ml: { xs: 0, sm: 1, md: 2, lg: 2 },
                // mt: { xs: 1, sm: 0, md: 0, lg: 0 },
                mb: { xs: -1, sm: -0, md: 1, lg: 0 },
                fontSize: {
                  xs: "0.7rem",
                  sm: "0.8rem",
                  md: "0.9rem",
                  lg: "0.8rem",
                },
                padding: {
                  xs: "3px 9px",
                  sm: "6px 12px",
                  md: "8px 15px",
                  lg: "5px 14px",
                },
                fontWeight: "bold",
              }}
            >
              BACK
            </LoadingButton>
          </Grid>
        </Grid>

        <form onSubmit={formik.handleSubmit}>
          <Grid
            container
            spacing={3}
            mt={4}
            display="flex"
            alignItems="stretch"
          >
            {/* Left Column */}
            <Grid item xs={12} md={6}>
              <Card
                sx={{ p: 2, borderRadius: 2, boxShadow: 3, height: "100%" }}
              >
                <Stack spacing={3}>
                  <Typography variant="h6">Product Information</Typography>

                  <ImageUploader
                    // maxFiles={3}
                    images={formik.values.image}
                    onFilesChange={(files) =>
                      formik.setFieldValue("image", files)
                    }
                  />
                  {formik.touched.image && formik.errors.image && (
                    <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                      {formik.errors.image}
                    </Typography>
                  )}
                </Stack>
              </Card>
            </Grid>

            {/* Right Column */}
            <Grid item xs={12} md={6}>
              <Card
                sx={{ p: 3, borderRadius: 2, boxShadow: 3, height: "97.3%" }}
              >
                <Stack spacing={3}>
                  <Box display="flex" gap={2}>
                    <TextField
                      label="Product Name"
                      name="product_name"
                      fullWidth
                      value={formik.values.product_name}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.product_name &&
                        Boolean(formik.errors.product_name)
                      }
                      helperText={
                        formik.touched.product_name &&
                        formik.errors.product_name
                      }
                      sx={{ flex: 0.6 }}
                    />
                    <Autocomplete
                      options={uom}
                      getOptionLabel={(option) => option.name || ""}
                      value={uom.find((c) => c.id == formik.values.uom) || null}
                      onChange={(event, newValue) => {
                        formik.setFieldValue(
                          "uom",
                          newValue ? newValue.id : ""
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="UOM"
                          variant="outlined"
                          fullWidth
                          error={
                            formik.touched.uom && Boolean(formik.errors.uom)
                          }
                          helperText={formik.touched.uom && formik.errors.uom}
                        />
                      )}
                      sx={{ flex: 0.4 }}
                    />
                  </Box>

                  <Box display="flex" gap={2}>
                    {/* SKU Field - takes 40% */}
                    <TextField
                      label="SKU"
                      name="sku"
                      fullWidth
                      sx={{ flex: 0.4 }}
                      value={formik.values.sku}
                      onChange={formik.handleChange}
                      error={formik.touched.sku && Boolean(formik.errors.sku)}
                      helperText={formik.touched.sku && formik.errors.sku}
                    />

                    {/* Category Dropdown - takes 60% */}
                    <Autocomplete
                      options={categories}
                      getOptionLabel={(option) => option.name || ""}
                      value={
                        categories.find(
                          (c) => c.id == formik.values.category
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        formik.setFieldValue(
                          "category",
                          newValue ? newValue.id : ""
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Category"
                          variant="outlined"
                          fullWidth
                          error={
                            formik.touched.category &&
                            Boolean(formik.errors.category)
                          }
                          helperText={
                            formik.touched.category && formik.errors.category
                          }
                        />
                      )}
                      sx={{ flex: 0.6 }}
                    />
                  </Box>

                  <Box display="flex" gap={2}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Color"
                        name="color"
                        fullWidth
                        sx={{ flex: 0.4 }}
                        value={formik.values.color}
                        onChange={formik.handleChange}
                        error={
                          formik.touched.color && Boolean(formik.errors.color)
                        }
                        helperText={formik.touched.color && formik.errors.color}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Size"
                        name="size"
                        fullWidth
                        sx={{ flex: 0.4 }}
                        value={formik.values.size}
                        onChange={formik.handleChange}
                        error={
                          formik.touched.size && Boolean(formik.errors.size)
                        }
                        helperText={formik.touched.size && formik.errors.size}
                      />
                    </Grid>
                  </Box>

                  <TextField
                    label="Barcode"
                    name="bar_code"
                    fullWidth
                    sx={{ flex: 0.4 }}
                    value={formik.values.bar_code}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.bar_code && Boolean(formik.errors.bar_code)
                    }
                    helperText={
                      formik.touched.bar_code && formik.errors.bar_code
                    }
                  />

                  <TextField
                    label="Description (Optional)"
                    name="description"
                    fullWidth
                    multiline
                    rows={4}
                    value={formik.values.description}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.description &&
                      Boolean(formik.errors.description)
                    }
                    helperText={
                      formik.touched.description && formik.errors.description
                        ? formik.errors.description
                        : `${formik.values.description?.length || 0}/500`
                    }
                  />
                  
                  {/* <Typography variant="h6">Pricing</Typography>
                  <Box display="flex" gap={2}>
                    <TextField
                      label="Buying Price"
                      name="buying_price"
                      type="text"
                      inputProps={{ min: 0 }}
                      fullWidth
                      value={formik.values.buying_price}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.buying_price &&
                        Boolean(formik.errors.buying_price)
                      }
                      helperText={
                        formik.touched.buying_price &&
                        formik.errors.buying_price
                      }
                    />
                    <TextField
                      label="Selling Price"
                      name="selling_price"
                      type="text"
                      fullWidth
                      inputProps={{ min: 0 }}
                      value={formik.values.selling_price}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.selling_price &&
                        Boolean(formik.errors.selling_price)
                      }
                      helperText={
                        formik.touched.selling_price &&
                        formik.errors.selling_price
                      }
                    />
                  </Box>

                  <Divider /> */}

                  <TextField
                    label="Reorder Level"
                    name="reorder_level"
                    type="number"
                    fullWidth
                    inputProps={{ min: 0 }}
                    value={formik.values.reorder_level}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.reorder_level &&
                      Boolean(formik.errors.reorder_level)
                    }
                    helperText={
                      (formik.touched.reorder_level &&
                        formik.errors.reorder_level) ||
                      "Re-order when stock falls to this level"
                    }
                  />

                  {/* <Typography variant="h6">Inventory</Typography>
                  <Box display="flex" gap={2}>
                    <TextField
                      label="Quantity"
                      name="quantity"
                      type="number"
                      fullWidth
                      disabled={id ? true : false}
                      value={formik.values.quantity}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.quantity &&
                        Boolean(formik.errors.quantity)
                      }
                      helperText={
                        formik.touched.quantity && formik.errors.quantity
                      }
                    />
                    <TextField
                      label="Reorder Level"
                      name="reorder_level"
                      type="number"
                      fullWidth
                      value={formik.values.reorder_level}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.reorder_level &&
                        Boolean(formik.errors.reorder_level)
                      }
                      helperText={
                        formik.touched.reorder_level &&
                        formik.errors.reorder_level
                      }
                    />
                    
                  </Box> */}

                  {/* <Divider /> */}

                  {/* <Typography variant="h6">Backorder Settings</Typography>
                  <FormControlLabel
                    control={
                      <Switch
                        name="allow_backorder"
                        checked={formik.values.allow_backorder}
                        onChange={() => {
                          formik.setFieldValue(
                            "allow_backorder",
                            !formik.values.allow_backorder
                          );
                        }}
                      />
                    }
                    label="Allow Backorder"
                  /> */}

                  {/* {formik.values.allow_backorder && (
                    <TextField
                      label="Backorder Limit"
                      name="backorder_limit"
                      type="number"
                      fullWidth
                      value={formik.values.backorder_limit}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.backorder_limit &&
                        Boolean(formik.errors.backorder_limit)
                      }
                      helperText={
                        formik.touched.backorder_limit &&
                        formik.errors.backorder_limit
                      }
                    />
                  )} */}

                  {/* <Divider />
                  {id && (
                    <>
                      <Typography variant="h6">Stock Adjustment</Typography>
                      <Box display="flex" gap={2}>
                        <FormControl fullWidth>
                          <InputLabel>Adjustment Type</InputLabel>
                          <Select
                            labelId="adjustment-type-label"
                            name="adjustmentType"
                            value={formik.values.adjustmentType}
                            onChange={formik.handleChange}
                            label="Adjustment Type"
                          >
                            <MenuItem value="add">Add</MenuItem>
                            <MenuItem value="deduct">Deduct</MenuItem>
                          </Select>
                        </FormControl>

                        <TextField
                          name="stockAdjustment"
                          type="number"
                          label="Quantity"
                          fullWidth
                          value={formik.values.stockAdjustment}
                          onChange={formik.handleChange}
                        />
                      </Box>

                      <TextField
                        name="note"
                        label="Reference Note"
                        fullWidth
                        multiline
                        rows={2}
                        value={formik.values.note}
                        onChange={formik.handleChange}
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formik.values.out_of_stock === 1}
                            onChange={(e) =>
                              formik.setFieldValue(
                                "out_of_stock",
                                e.target.checked ? 1 : 0
                              )
                            }
                          />
                        }
                        label="Mark as Out of Stock"
                      />
                    </>
                  )} */}
                </Stack>
              </Card>
            </Grid>

            {/* Submit Button */}
            <Grid item xs={12}>
              <Box display="flex" justifyContent="center" mt={5} pr={2}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={loading}
                >
                  Submit
                </Button>
              </Box>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Layout>
  );
};

export default Products;
